export default __webpack_public_path__ + "static/media/9.cb0fb225.pdf";